import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private injector: Injector
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        () => {},
        error => {
          if (error.status === 500) {
            // console.log(error)
            // Redirect to error page for specific screens
            if (this.isErrorPageRequired(request.url)) {
              this.router.navigate(['/error/page-not-found']);
            }
          } else if (error.status === 429) {
            // SECURITY FIX: VAPT Issue #3 - Iteration 2
            // Handle rate limiting (Too Many Requests)
            const toastr = this.injector.get(ToastrService);
            const retryAfter = error.headers?.get('Retry-After');
            const message = retryAfter
              ? `Too many requests. Please try again in ${retryAfter} seconds.`
              : 'Too many requests. Please wait a moment before trying again.';

            toastr.warning(message, 'Rate Limit Exceeded', {
              timeOut: 5000,
              closeButton: true,
            });
          }
        }
      )
    );
  }

  private isErrorPageRequired(url: string): boolean {
    // Define the screens where you want to redirect to the error page
    const requiredScreens = [
      'Violations/GetByID',
      'Advertising/GetViewAdvertising',
    ];
    return requiredScreens.some(screen => url.includes(screen));
  }
}
